import {ValueObject} from '@s-ui/domain'

export class VehicleInsightsValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.bodyType
   * @param {String} params.make
   * @param {Number} params.countVersions
   * @param {Number} params.countDoorsOptions
   * @param {Number} params.minPrice
   * @param {Number} params.maxPrice
   * @param {Number} params.minLength
   * @param {Number} params.minWidth
   * @param {Number} params.minHeight
   * @param {Number} params.maxLength
   * @param {Number} params.maxWidth
   * @param {Number} params.maxHeight
   * @param {Number} params.minLuggageCapacity
   * @param {Number} params.maxLuggageCapacity
   * @param {Array<String>} params.fuelTypes
   * @param {String} params.minFuelType
   * @param {String} params.maxFuelType
   * @param {Number} params.minHp
   * @param {Number} params.maxHp
   * @param {Number} params.minAcceleration
   * @param {Number} params.maxAcceleration
   * */
}
